import { memo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ConflictErrorAlert(props) {
  return /*#__PURE__*/_jsx(Overlay, {
    centerContent: true,
    contextual: true,
    use: "light",
    width: "100%",
    padding: "0",
    children: /*#__PURE__*/_jsx(Alert, {
      "data-test-id": "conflict-error-alert",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.errors.conflict.title"
      }),
      paddingBlock: "400",
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "conflict-alert-message",
          message: "app.escalations.errors.conflict.body"
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "conflict-error-alert-resolve-button",
          onClick: props.onResolve,
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.escalations.errors.conflict.resolve"
          })
        })]
      })
    })
  });
}
ConflictErrorAlert.propTypes = {
  onResolve: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(ConflictErrorAlert);